import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { supabase } from "./supabaseClient";

// Handle OAuth redirect — parse tokens from URL hash before rendering
supabase.auth.getSession();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

reportWebVitals();
